<template>
  <div class="work_detail">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img  v-if="URL_MAQIN==1"  src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>提问详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content_box clearfix">
        <!-- 单选 -->
        <div class="content_box_r">
          <div class="max_box" v-if="comment.type=='单选题' || comment.type=='判断题' ">
            <div class="content_box_r_top">提问详情</div>
            <div class="content_box_r_bottom">
              <div class="queset_name">{{comment.type}}</div>
              <div class="queset_content">
                <div class="name" v-html="comment.parentStem"></div>
                <div class="name" v-html="comment.stem"></div>
                <div class="answer">
                  <div
                    class="answer_list clearfix"
                    v-for="(item,index) in comment.metas"
                    :key="index"
                  >
                    <div class="key" :class="item.key==comment.answer? 'lv' :''">{{item.key}}</div>
                    <!-- <div class="key_name">{{item.meta}}</div> -->
                      <pre class="key_name" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item.meta"></pre>
                  </div>
                </div>
              </div>
            </div>
            <!-- tiwen -->
            <div class="quiz_box">
              <div class="quiz_item">
                <div class="title clearfix">
                  <span></span>
                  我的提问
                </div>
                <div class="content">{{comment.comments.content}}</div>
              </div>
              <div class="quiz_item">
                <div class="title clearfix">
                  <span></span>
                  老师的回答
                </div>
                <pre
                  class="content"
                  v-for="(item,index) in comment.respond"
                  :key="index"
                >{{item.content}}</pre>
              </div>
            </div>
          </div>
          <!-- 多选 -->
          <div class="max_box" v-else-if="comment.type=='多选题' || comment.type=='不定项选择题' ">
            <div class="content_box_r_top">提问详情</div>
            <div class="content_box_r_bottom">
              <div class="queset_name">{{comment.type}}</div>
              <div class="queset_content">
                <div class="name" v-html="comment.parentStem"></div>
                <div class="name" v-html="comment.stem"></div>
                <div class="answer">
                  <div
                    class="answer_list clearfix"
                    v-for="(item,index) in comment.metas"
                    :key="index"
                  >
                    <div
                      class="key more"
                      :class="item.key==true_answer[index]? 'lv' :''"
                    >{{item.key}}</div>
                    <!-- <div class="key_name">{{item.meta}}</div> -->
                      <pre class="key_name" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item.meta"></pre>

                  </div>
                </div>
              </div>
            </div>
            <!-- tiwen -->
            <div class="quiz_box">
              <div class="quiz_item">
                <div class="title clearfix">
                  <span></span>
                  我的提问
                </div>
                <div class="content">{{comment.comments.content}}</div>
              </div>
              <div class="quiz_item">
                <div class="title clearfix">
                  <span></span>
                  老师的回答
                </div>
               <pre
                  class="content"
                  v-for="(item,index) in comment.respond"
                  :key="index"
                >{{item.content}}</pre>
              </div>
            </div>
          </div>
          <!-- 判断 -->
          <!-- 不定项 -->
          <!-- 其他 -->
          <div class="max_box" v-else>
            <div class="content_box_r_top">提问详情</div>
            <div class="content_box_r_bottom">
              <div class="queset_name">{{comment.type}}</div>
              <div class="queset_content">
               <div class="name" v-html="comment.parentStem"></div>
                <div class="name" v-html="comment.stem"></div>
                <div class="answer">
                  <div class="answer_text" v-html="comment.answer"></div>
                </div>
              </div>
            </div>
            <!-- tiwen -->
            <div class="quiz_box">
              <div class="quiz_item">
                <div class="title clearfix">
                  <span></span>
                  我的提问
                </div>
                <div class="content">{{comment.comments.content}}</div>
              </div>
              <div class="quiz_item">
                <div class="title clearfix">
                  <span></span>
                  老师的回答
                </div>
               <pre
                  class="content"
                  v-for="(item,index) in comment.respond"
                  :key="index"
                >{{item.content}}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CommentsInfo } from "@/api/index";
export default {
  data() {
    return {
      comment: {},
      true_answer: [],
      MAIN_CLASS:this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN:this.GLOBAL.PLATFORM,
    };
  },
  mounted() {
    this.$utils.banCopy()
    this.commentsInfo(this.$route.query.id, "question");
  },
  methods: {
    commentsInfo(id, type) {
      CommentsInfo(id, type).then(res => {
        if (
          res.data.data.type == "多选题" ||
          res.data.data.type == "不定项选择题"
        ) {
          let arr = res.data.data.answer.split("");
          for (let i = 0; i < res.data.data.metas.length; i++) {
            for (let j = 0; j < arr.length; j++) {
              if (res.data.data.metas[i].key == arr[j]) {
                this.true_answer[i] = res.data.data.metas[i].key;
              }
            }
          }
          this.comment = res.data.data;
        } else {
          console.log("评论数据", res.data.data);
          this.comment = res.data.data;
        }
      });
    },
    close_click() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_r {
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_r_top {
        padding: 25px 53px;
        border-bottom: 1px solid #eee;
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .content_box_r_bottom {
        padding: 32px 80px;
        .queset_name {
          font-size: 20px;
          font-weight: 500;
          color: rgba(43, 43, 43, 1);
          margin-bottom: 34px;
        }
        .queset_content {
          .name {
            width: 587px;
            font-size: 18px;
            font-weight: 500;
            color: rgba(43, 43, 43, 1);
            margin-bottom: 40px;
          }
          .answer {
            .answer_text {
              width: 578px;
              background: rgba(249, 249, 249, 1);
              border: 1px solid rgba(238, 238, 238, 1);
              padding: 20px;
            }
            .answer_list {
              .key {
                float: left;
                width: 34px;
                height: 34px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                border-radius: 50%;
                font-size: 16px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                line-height: 34px;
                margin-bottom: 42px;
              }
              .more {
                border-radius: 4px;
                border: 1px solid rgba(204, 204, 204, 1);
              }
              .key_name {
                float: left;
                margin-left: 24px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(43, 43, 43, 1);
                line-height: 34px;
              }
              .lv {
                background: rgba(12, 213, 109, 0.2);
                border: 2px solid rgba(12, 213, 109, 1);
                color: #0cd56d;
              }
            }
          }
        }
      }
      .quiz_box {
        padding: 24px 45px;
        .quiz_item {
          padding: 28px 0;
          &:first-of-type {
            border-top: 1px solid #eee;
          }
          .title {
            font-size: 18px;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            margin-bottom: 25px;
            span {
              display: block;
              width: 6px;
              height: 30px;
              background: rgba(250, 220, 30, 1);
              border-radius: 3px;
              float: left;
              margin-right: 16px;
            }
          }
          .content {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
      }
    }
  }
}
.main_kjc {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_r {
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_r_top {
        padding: 25px 53px;
        border-bottom: 1px solid #eee;
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .content_box_r_bottom {
        padding: 32px 80px;
        .queset_name {
          font-size: 20px;
          font-weight: 500;
          color: rgba(43, 43, 43, 1);
          margin-bottom: 34px;
        }
        .queset_content {
          .name {
            width: 587px;
            font-size: 18px;
            font-weight: 500;
            color: rgba(43, 43, 43, 1);
            margin-bottom: 40px;
          }
          .answer {
            .answer_text {
              width: 578px;
              background: rgba(249, 249, 249, 1);
              border: 1px solid rgba(238, 238, 238, 1);
              padding: 20px;
            }
            .answer_list {
              .key {
                float: left;
                width: 34px;
                height: 34px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                border-radius: 50%;
                font-size: 16px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                line-height: 34px;
                margin-bottom: 42px;
              }
              .more {
                border-radius: 4px;
                border: 1px solid rgba(204, 204, 204, 1);
              }
              .key_name {
                float: left;
                margin-left: 24px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(43, 43, 43, 1);
                line-height: 34px;
              }
              .lv {
                background: rgba(12, 213, 109, 0.2);
                border: 2px solid rgba(12, 213, 109, 1);
                color: #0cd56d;
              }
            }
          }
        }
      }
      .quiz_box {
        padding: 24px 45px;
        .quiz_item {
          padding: 28px 0;
          &:first-of-type {
            border-top: 1px solid #eee;
          }
          .title {
            font-size: 18px;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            margin-bottom: 25px;
            span {
              display: block;
              width: 6px;
              height: 30px;
              background: rgba(12, 213, 109, 1);
              border-radius: 3px;
              float: left;
              margin-right: 16px;
            }
          }
          .content {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
      }
    }
  }
}
</style>